import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
  selector: '[agenciaMask]'
})
export class AgenciaBancariaMaskDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: any) {
    let value = event.target.value || '';

    value = value.replace(/\D/g, '');
    if (value.length > 6) {
      value = value.substring(0, 6);
    }

    // Aplica máscara 000000
    value = value.replace(/\D/g, '').slice(0, 6);

    this.ngControl.control.setValue(value, { emitEvent: false });
  }
}
